export const continents = [
    '오세아니아',
    '아시아',
    '아프리카',
    '남아메리카',
    '북아메리카',
    '유럽'
]

export const countryCategory = {
    '오세아니아': [
        "New Zealand",
        "Australia"
    ],
    '아시아': [
        "Israel",
        "United Arab Emirates",
        "Saudi Arabia",
        "Taiwan",
        "Singapore",
        "Kazakhstan",
        "Cyprus",
        "Kuwait",
        "Uzbekistan",
        "Japan",
        "The Republic of Korea",
        "Philippines",
        "Thailand",
        "Mongolia",
        "Malaysia",
        "China",
        "Vietnam",
        "Hong Kong",
        "Armenia",
        "Tajikistan",
        "Nepal",
        "Indonesia",
        "Bangladesh",
        "Laos",
        "Georgia",
        "Iraq",
        "Iran",
        "Turkey",
        "Cambodia",
        "Pakistan",
        "Myanmar",
        "Sri Lanka",
        "Yemen",
        "Jordan",
        "India"
    ],
    '남아메리카': [
        "Uruguay",
        "Brazil",
        "Chile",
        "Argentina",
        "Colombia",
        "Bolivia",
        "Paraguay",
        "Peru",
        "Ecuador",
        "Venezuela"
    ],
    '북아메리카': [
        "Canada",
        "United States",
        "Costa Rica",
        "Panama",
        "Guatemala",
        "Mexico",
        "Honduras",
        "Jamaica",
        "Dominican Republic"
    ],
    '유럽': [
        "Finland",
        "Denmark",
        "Iceland",
        "Switzerland",
        "Netherlands",
        "Luxembourg",
        "Sweden",
        "Norway",
        "Austria",
        "Ireland",
        "Germany",
        "United Kingdom",
        "Czechia",
        "Belgium",
        "France",
        "Slovenia",
        "Romania",
        "Spain",
        "Italy",
        "Malta",
        "Slovakia",
        "Serbia",
        "Poland",
        "Hungary",
        "Portugal",
        "Greece",
        "Russian Federation",
        "Bulgaria",
        "North Macedonia",
        "Ukraine"
    ],
    '아프리카': [
        "South Africa",
        "Gambia",
        "Congo",
        "Morocco",
        "Ghana",
        "Uganda",
        "Nigeria",
        "Kenya",
        "Madagascar",
        "Egypt",
        "Ethiopia",
        "Tanzania",
        "Zimbabwe"
    ]
}
